export default "__VITE_ASSET__88e69bc7__"